import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { CustomNotificationPopup } from './CustomNotificationPopup';

export const CUSTOM_NOTIFICATION_POPUP = Symbol('CUSTOM_NOTIFICATION');

export const useCustomNotificationPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(CUSTOM_NOTIFICATION_POPUP, CustomNotificationPopup);
  });

  const openCustomNotificationPopup = useCallback(
    ({ notification, onButtonClick, onClose }) => {
      popups.openPopup(CUSTOM_NOTIFICATION_POPUP, {
        notification,
        onButtonClick: (linkFromNotification) => {
          popups.closePopup(CUSTOM_NOTIFICATION_POPUP);
          onButtonClick(linkFromNotification);
        },
        onClose,
      });
    },
    [popups]
  );

  return {
    openCustomNotificationPopup,
  };
};
